import { Component, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';


@Component({
  selector: 'imagen-upload',
  template: `   
    <div class="img-wrapper">
      <img [src]="((_value === null || _value === '') ? defaultImage: _value)"/>
    </div>
    <kendo-textbox-container>
      <kendo-upload [multiple]="false" [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" (success)="onUploadSuccess($event)"></kendo-upload>
    </kendo-textbox-container>              
    `,
    styles: [`      
      .k-textbox-container, input.k-textbox {
        width: 100%;
      }
      .img-wrapper {
        text-align: center;
      }
      .img-wrapper img {
        height: 128px;
        margin: 5px; 
        border-radius: 50%!important;
      }
    `],
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        multi:true,
        useExisting: ImagenUploadComponent
      }     
    ]
})
export class ImagenUploadComponent implements ControlValueAccessor {      

  //Input: table
  private _folder : string = '__FOLDER__';

  @Input()
  set folder(value: string) {
    this._folder = (value && value.trim());
    this.defaultImage = `${environment.apiUrl}/uploads/${this._folder}/_DEFAULT.png`;
    // console.log('set table = ' + this._table);
  }

  get folder(): string { return this._folder; }

  //Input: defaultImage
  protected defaultImage: string = '__DEFAULT_IMAGE__';

  //Input: value
  protected _value : string = '';

  //@Override
  protected onChange = (value) => {};

  //@Override
  protected onTouched = () => {};

  //@Override
  protected touched = false;

  //@Override
  protected disabled = false;

  protected uploadSaveUrl: string = 'saveUrl'; // should represent an actual API endpoint
  
  protected uploadRemoveUrl: string = 'removeUrl'; // should represent an actual API endpoint
  

  //@Override
  public writeValue(value: string) {
    this._value = value;
  }

  //@Override
  public registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  //@Override
  public registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  //@Override
  protected markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  //@Override
  public setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  //@Override
  // public validate(control: AbstractControl): ValidationErrors | null {
  //   const value = control.value;
  //   // if (value < 0) {
  //     return {
  //       valid: {
  //         value
  //       }
  //     };
  //   // }
  // }

  constructor(protected http: HttpClient) {
    this._value = this.defaultImage;   
  }

  public valueChange(value: any): void {

    this.markAsTouched();
    if (!this.disabled) {
      this._value = value;
      this.onChange(this._value);
    }

  }

  public onUploadSuccess(e: any): void {
    let t = this;
    // console.log(e.operation);
    if(e.operation == 'upload'){
      // console.log('onUploadSuccess', e.files[0].name, e);
      const formData: FormData = new FormData();
      formData.append('folder', t.folder);
      formData.append('image', e.files[0].rawFile, e.files[0].name);
      this.http
        .post(`${environment.apiUrl}/upload`, formData)
        // .map((e) => { file: e.file; })
        .subscribe(
          (res: any) => {
            console.log(`UPLOAD in folder ${this.folder} is successful: `, res);
            this.valueChange(res.file);
          },
          (fail) => {        
            console.log("Error", fail);
            // this.alertService.showError(fail.error.detail.sql + ' ' + fail.error.detail.sqlMessage);
          }
        );
        // .catch(function(e) { console.log(e); return true; });

    }
    else {
      //remove
      console.log('onRemoveSuccess', e);
      this.valueChange(this.defaultImage);
    }
    
  };

}
